/*jshint esversion: 6 */


//redefine console.log
//console.log = function() {}; 

// eslint-disable-next-line no-unused-vars
const _ = require("lodash"); 

//Import Moment
import moment from 'moment';
window.moment = moment;

// //Import Vue
import * as  Vue from 'vue';
window.Vue = Vue;